<template>
  <div>
    <footer class="footer">
      <div class="footer__container">
        <div class="site-map">
          <div
            v-if="LoadingSkeleton"
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <div style="display: flex; justify-content: space-between">
              <Skeletor
                style="border-radius: 10px; background: rgb(194, 209, 207)"
                width="200"
                height="200"
                class="ite-map__column"
              />
              <Skeletor
                style="
                  border-radius: 10px;
                  background: rgb(194, 209, 207);
                  margin-right: 30px;
                "
                width="200"
                height="200"
                class="ite-map__column"
              />
              <Skeletor
                style="
                  border-radius: 10px;
                  background: rgb(194, 209, 207);
                  margin-right: 30px;
                "
                width="200"
                height="200"
                class="ite-map__column"
              />
            </div>

            <div>
              <Skeletor
                style="border-radius: 10px; background: rgb(194, 209, 207)"
                width="350"
                height="200"
                class="ite-map__column"
              />
            </div>
          </div>

          <!-- <div
            v-if="!LoadingSkeleton"
            class="site-map__column site-map__column--sm"
          >
            <p class="site-map__title">نحوه خرید اشتراک</p>
            <router-link to="/guide" class="site-map__item">راهنما</router-link>
            <a
              href="/help/faq/payment-method/"
              target="_blank"
              class="site-map__item"
              >شیوه‌های پرداخت</a
            > -->
          <!-- </div> -->
          <!-- <div
            v-if="!LoadingSkeleton"
            class="site-map__column site-map__column--sm"
          >
            <p class="site-map__title">خدمات مشتریان</p>
            <router-link to="/about-us" class="site-map__item"
              >پرسش‌های متداول</router-link
            >
            <router-link to="/about-us" class="site-map__item"
              >حریم شخصی کاربران</router-link
            >
          </div> -->
          <div
            v-if="!LoadingSkeleton"
            class="site-map__column site-map__column--sm"
          >
            <p class="site-map__title">با شمال املاک</p>
            <router-link to="/about-us" class="site-map__item"
              >درباره شمال املاک</router-link
            >

            <router-link to="/contact-us" class="site-map__item"
              >تماس با ما</router-link
            >
          </div>
          <div
            v-if="!LoadingSkeleton"
            class="site-map__column site-map__column--lg"
          >
            <img src="/img/amlakLogo.png" alt="شمال املاک" />

            <p class="site-map__description">
              شمال املاک را در شبکه‌های اجتماعی دنبال کنید:
            </p>

            <a
              :href="$store.state.c_set.telegram"
              target="_blank"
              rel="noopener"
              class="site-map__social"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="16"
                  cy="16"
                  r="14"
                  fill="url(#paint0_linear_87_7225)"
                />
                <path
                  d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_87_7225"
                    x1="16"
                    y1="2"
                    x2="16"
                    y2="30"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#37BBFE" />
                    <stop offset="1" stop-color="#007DBB" />
                  </linearGradient>
                </defs>
              </svg>
            </a>

            <a
              :href="$store.state.c_set.whatsapp"
              target="_blank"
              rel="noopener"
              class="site-map__social"
            >
              <svg
                fill="green"
                height="24"
                width="24"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 308 308"
                xml:space="preserve"
              >
                <g id="XMLID_468_">
                  <path
                    id="XMLID_469_"
                    d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
                    c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
                    c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
                    c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
                    c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
                    c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
                    c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
                    c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
                    c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
                    C233.168,179.508,230.845,178.393,227.904,176.981z"
                  />
                  <path
                    id="XMLID_470_"
                    d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
                    c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
                    c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
                     M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
                    l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
                    c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
                    C276.546,215.678,222.799,268.994,156.734,268.994z"
                  />
                </g>
              </svg>
            </a>

            <a
              :href="$store.state.c_set.instagram"
              target="_blank"
              rel="noopener"
              class="site-map__social"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 102 102"
                id="instagram"
              >
                <defs>
                  <radialGradient
                    id="a"
                    cx="6.601"
                    cy="99.766"
                    r="129.502"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset=".09" stop-color="#fa8f21"></stop>
                    <stop offset=".78" stop-color="#d82d7e"></stop>
                  </radialGradient>
                  <radialGradient
                    id="b"
                    cx="70.652"
                    cy="96.49"
                    r="113.963"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset=".64"
                      stop-color="#8c3aaa"
                      stop-opacity="0"
                    ></stop>
                    <stop offset="1" stop-color="#8c3aaa"></stop>
                  </radialGradient>
                </defs>
                <path
                  fill="url(#a)"
                  d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"
                ></path>
                <path
                  fill="url(#b)"
                  d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"
                ></path>
                <path
                  fill="#fff"
                  d="M461.114,477.413a12.631,12.631,0,1,1,12.629,12.632,12.631,12.631,0,0,1-12.629-12.632m-6.829,0a19.458,19.458,0,1,0,19.458-19.458,19.457,19.457,0,0,0-19.458,19.458m35.139-20.229a4.547,4.547,0,1,0,4.549-4.545h0a4.549,4.549,0,0,0-4.547,4.545m-30.99,51.074a20.943,20.943,0,0,1-7.037-1.3,12.547,12.547,0,0,1-7.193-7.19,20.923,20.923,0,0,1-1.3-7.037c-.184-3.994-.22-5.194-.22-15.313s.04-11.316.22-15.314a21.082,21.082,0,0,1,1.3-7.037,12.54,12.54,0,0,1,7.193-7.193,20.924,20.924,0,0,1,7.037-1.3c3.994-.184,5.194-.22,15.309-.22s11.316.039,15.314.221a21.082,21.082,0,0,1,7.037,1.3,12.541,12.541,0,0,1,7.193,7.193,20.926,20.926,0,0,1,1.3,7.037c.184,4,.22,5.194.22,15.314s-.037,11.316-.22,15.314a21.023,21.023,0,0,1-1.3,7.037,12.547,12.547,0,0,1-7.193,7.19,20.925,20.925,0,0,1-7.037,1.3c-3.994.184-5.194.22-15.314.22s-11.316-.037-15.309-.22m-.314-68.509a27.786,27.786,0,0,0-9.2,1.76,19.373,19.373,0,0,0-11.083,11.083,27.794,27.794,0,0,0-1.76,9.2c-.187,4.04-.229,5.332-.229,15.623s.043,11.582.229,15.623a27.793,27.793,0,0,0,1.76,9.2,19.374,19.374,0,0,0,11.083,11.083,27.813,27.813,0,0,0,9.2,1.76c4.042.184,5.332.229,15.623.229s11.582-.043,15.623-.229a27.8,27.8,0,0,0,9.2-1.76,19.374,19.374,0,0,0,11.083-11.083,27.716,27.716,0,0,0,1.76-9.2c.184-4.043.226-5.332.226-15.623s-.043-11.582-.226-15.623a27.786,27.786,0,0,0-1.76-9.2,19.379,19.379,0,0,0-11.08-11.083,27.748,27.748,0,0,0-9.2-1.76c-4.041-.185-5.332-.229-15.621-.229s-11.583.043-15.626.229"
                  transform="translate(-422.637 -426.196)"
                ></path>
              </svg>
            </a>
          </div>
        </div>

        <Skeletor
          v-if="LoadingSkeleton"
          style="border-radius: 10px; background: rgb(194, 209, 207)"
          height="72"
          class="support__title"
        />
        <section v-if="!LoadingSkeleton" class="app-store">
          <div class="app-store__container">
            <a href="/app" class="app-store__wrapper">
              <p class="app-store__title">دانلود اپلیکیشن شمال املاک</p>
            </a>
            <a
              href="https://cafebazaar.ir/app/com.abarline.amlak"
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer"
              class="app-store__item"
            >
              <img
                src="@/assets/img/bazar.png"
                alt="دریافت از کافه‌بازار"
                loading="lazy"
              />
            </a>

            <a
              href="https://shomalamlak.ir/shomalamlak.apk"
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer"
              class="app-store__item"
            >
              <img
                src="@/assets/img/direct.png"
                alt="دریافت از سایت"
                loading="lazy"
              />
            </a>
          </div>
        </section>

        <section class="support">
          <Skeletor
            v-if="LoadingSkeleton"
            style="border-radius: 10px; background: rgb(194, 209, 207)"
            width="350"
            height="40"
            class="support__title"
          />
          <div style="display: flex; gap: 20px">
            <Skeletor
              v-if="LoadingSkeleton"
              style="border-radius: 10px; background: rgb(194, 209, 207)"
              width="170"
              height="40"
              class="support__title"
            />
            <Skeletor
              v-if="LoadingSkeleton"
              style="border-radius: 10px; background: rgb(194, 209, 207)"
              width="170"
              height="40"
              class="support__title"
            />
          </div>
          <span
            v-if="!LoadingSkeleton && $store.state.c_set.phone"
            class="support__item"
          >
            تلفن پشتیبانی:
            <a
              :href="`tel:${$store.state.c_set.phone}`"
              class="support__link"
              >{{ $store.state.c_set.phone }}</a
            >
          </span>
          <span
            v-if="!LoadingSkeleton && $store.state.c_set.email"
            class="support__item"
          >
            ایمیل:
            <a
              :href="`mailto:${$store.state.c_set.email}`"
              class="support__link"
              >{{ $store.state.c_set.email }}</a
            >
          </span>
        </section>
      </div>

      <div class="copyright">
        <div class="copyright__container">
          <div v-if="LoadingSkeleton" class="copyright__wrapper">
            <Skeletor
              style="border-radius: 10px; background: rgb(194, 209, 207)"
              width="400"
              height="80"
            />
          </div>

          <div v-if="!LoadingSkeleton" class="copyright__wrapper">
            <p class="copyright__branding">
              <strong>طراحی و توسعه شمال املاک،</strong> ایران سال 1404
            </p>
            <p class="copyright__description">
              © کلیه حقوق این سایت محفوظ و متعلق به
              <strong>شمال املاک</strong> است.
            </p>
          </div>

          <Skeletor
            v-if="LoadingSkeleton"
            style="background: rgb(194, 209, 207)"
            class="copyright__item"
          />
          <Skeletor
            v-if="LoadingSkeleton"
            style="background: rgb(194, 209, 207)"
            class="copyright__item"
          />
          <Skeletor
            v-if="LoadingSkeleton"
            style="background: rgb(194, 209, 207)"
            class="copyright__item"
          />
          <a
            v-if="!LoadingSkeleton"
            referrerpolicy="origin"
            target="_blank"
            rel="noopener"
            class="copyright__item"
          >
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=576174&Code=xAFRrlbK58tPzkiJicOZVBIYGv7qXMVX"
              ><img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=576174&Code=xAFRrlbK58tPzkiJicOZVBIYGv7qXMVX"
                alt=""
                style="cursor: pointer"
                code="xAFRrlbK58tPzkiJicOZVBIYGv7qXMVX"
            /></a>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
export default {
  name: "FooterUser",
  data() {
    return {
      LoadingSkeleton: false,
    };
  },
  components: { Skeletor },
  methods: {
    relaodPage() {
      setTimeout(() => {
        this.LoadingSkeleton = false;
      }, 200);
    },
  },
  mounted() {
    this.relaodPage();
  },
};
</script>

<style scoped></style>
